"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Dialog = void 0;
const Dialog_1 = __importDefault(require("@material-ui/core/Dialog"));
const DialogActions_1 = __importDefault(require("@material-ui/core/DialogActions"));
const DialogContent_1 = __importDefault(require("@material-ui/core/DialogContent"));
const DialogTitle_1 = __importDefault(require("@material-ui/core/DialogTitle"));
const lib_palette_1 = __importDefault(require("@opsbase/lib-palette"));
const web_css_1 = __importDefault(require("@opsbase/web-css"));
const SysLangPicker_1 = __importDefault(require("@opsbase/web-ctrl-syslang/SysLangPicker/SysLangPicker"));
const CloseDialogIcon_1 = __importDefault(require("@opsbase/web-icons/icons/CloseDialogIcon"));
const Horizontal_1 = __importDefault(require("@opsbase/web-layout/Horizontal"));
const Pane_1 = __importDefault(require("@opsbase/web-layout/Pane"));
const Vertical_1 = __importDefault(require("@opsbase/web-layout/Vertical"));
const useNav_1 = __importDefault(require("@opsbase/web-nav/useNav"));
const FeaturedTab_1 = __importDefault(require("@opsbase/web-tabs/FeaturedTab"));
const Tabs_1 = __importDefault(require("@opsbase/web-tabs/Tabs"));
const IconButton_1 = __importDefault(require("@opsbase/web-ui/IconButton"));
const Spinner_1 = __importDefault(require("@opsbase/web-ui/Spinner"));
const react_1 = __importStar(require("react"));
const DialogEditableTitle_1 = __importDefault(require("./DialogEditableTitle"));
const DialogSize_1 = __importDefault(require("./DialogSize"));
const makeMyClasses = (size, white, tabs = []) => {
    var _a, _b, _c, _d;
    return ({
        title: {
            padding: tabs.length ? '8px 24px 0' : '8px 24px',
            minHeight: tabs.length ? undefined : 54,
            height: tabs.length ? undefined : 54,
        },
        paper: {
            overflowX: 'hidden',
            minWidth: (_a = dialogStyle[size]) === null || _a === void 0 ? void 0 : _a.minWidth,
            maxWidth: (_b = dialogStyle[size]) === null || _b === void 0 ? void 0 : _b.maxWidth,
            minHeight: (_c = dialogStyle[size]) === null || _c === void 0 ? void 0 : _c.minHeight,
            maxHeight: (_d = dialogStyle[size]) === null || _d === void 0 ? void 0 : _d.maxHeight,
        },
        content: {
            padding: 0,
            backgroundColor: white ? undefined : lib_palette_1.default.WhiteSmoke.main,
            borderTop: white ? undefined : '1px solid ' + lib_palette_1.default.BorderGrey.main,
            borderBottom: white ? undefined : '1px solid ' + lib_palette_1.default.BorderGrey.main,
        },
        floatCloseButton: {
            position: 'absolute',
            right: 8,
            top: 8,
            zIndex: 100,
        },
    });
};
const dialogStyle = {
    [DialogSize_1.default.X400_Y250]: { minHeight: 100, maxHeight: 250, width: 400 },
    [DialogSize_1.default.X450_Y250]: { height: 250, width: 450 },
    [DialogSize_1.default.X450_Y350]: { height: 350, width: 450 },
    [DialogSize_1.default.X550_Y350]: { height: 350, width: 550 },
    [DialogSize_1.default.X550_Y450]: { height: 450, width: 550 },
    [DialogSize_1.default.X550_Y500]: { height: 500, width: 550 },
    [DialogSize_1.default.X600_Y550]: { height: 550, width: 600 },
    [DialogSize_1.default.X800_Y400]: { height: 400, width: 800 },
    [DialogSize_1.default.X800_Y550]: { height: 550, width: 800 },
    [DialogSize_1.default.X800_Y600]: { height: 600, width: 800 },
    [DialogSize_1.default.X800_YFULL]: { minHeight: 'calc(100% - 32px)', width: 800 },
    [DialogSize_1.default.X1000_Y500]: { height: 500, width: 1000 },
    [DialogSize_1.default.X1000_YFULL]: { minHeight: 'calc(100% - 32px)', width: 1000 },
    [DialogSize_1.default.XFULL_YFULL]: { minHeight: 'calc(100% - 32px)', minWidth: 'calc(100% - 32px)' },
};
const titleStyle = {
    [DialogSize_1.default.X400_Y250]: { maxWidth: 300 },
    [DialogSize_1.default.X450_Y250]: { maxWidth: 350 },
    [DialogSize_1.default.X450_Y350]: { maxWidth: 350 },
    [DialogSize_1.default.X550_Y350]: { maxWidth: 450 },
    [DialogSize_1.default.X550_Y450]: { maxWidth: 500 },
    [DialogSize_1.default.X550_Y500]: { maxWidth: 450 },
    [DialogSize_1.default.X600_Y550]: { maxWidth: 450 },
    [DialogSize_1.default.X800_Y400]: { maxWidth: 700 },
    [DialogSize_1.default.X800_Y550]: { maxWidth: 700 },
    [DialogSize_1.default.X800_Y600]: { maxWidth: 700 },
    [DialogSize_1.default.X800_YFULL]: { maxWidth: 500 },
    [DialogSize_1.default.X1000_Y500]: { maxWidth: 700 },
    [DialogSize_1.default.X1000_YFULL]: { maxWidth: 700 },
    [DialogSize_1.default.XFULL_YFULL]: { maxWidth: 700 },
};
const innerStyle = {
    [DialogSize_1.default.X400_Y250]: {},
    [DialogSize_1.default.X550_Y450]: { height: 0, overflow: 'hidden' },
    [DialogSize_1.default.X450_Y250]: { height: 0, overflow: 'hidden' },
    [DialogSize_1.default.X450_Y350]: { height: 0, overflow: 'hidden' },
    [DialogSize_1.default.X550_Y350]: { height: 0, overflow: 'hidden' },
    [DialogSize_1.default.X550_Y500]: { height: 0, overflow: 'hidden' },
    [DialogSize_1.default.X600_Y550]: { height: 0, overflow: 'hidden' },
    [DialogSize_1.default.X800_Y550]: { height: 0, overflow: 'hidden' },
    [DialogSize_1.default.X800_Y400]: { height: 0, overflow: 'hidden' },
    [DialogSize_1.default.X800_Y600]: { height: 0, overflow: 'hidden' },
    [DialogSize_1.default.X800_YFULL]: { height: 0, overflow: 'hidden' },
    [DialogSize_1.default.X1000_Y500]: { height: 0, overflow: 'hidden' },
    [DialogSize_1.default.X1000_YFULL]: { height: 0, overflow: 'hidden' },
    [DialogSize_1.default.XFULL_YFULL]: { height: 0, overflow: 'hidden' },
};
const scrollerStyle = {
    [DialogSize_1.default.X400_Y250]: { position: 'relative' },
    [DialogSize_1.default.X450_Y250]: {},
    [DialogSize_1.default.X450_Y350]: {},
    [DialogSize_1.default.X550_Y350]: {},
    [DialogSize_1.default.X550_Y450]: {},
    [DialogSize_1.default.X550_Y500]: {},
    [DialogSize_1.default.X600_Y550]: {},
    [DialogSize_1.default.X800_Y400]: {},
    [DialogSize_1.default.X800_Y550]: {},
    [DialogSize_1.default.X800_Y600]: {},
    [DialogSize_1.default.X800_YFULL]: {},
    [DialogSize_1.default.X1000_Y500]: {},
    [DialogSize_1.default.X1000_YFULL]: {},
    [DialogSize_1.default.XFULL_YFULL]: {},
};
const DEFAULT_TABS = [];
exports.Dialog = react_1.default.forwardRef((props, ref) => {
    var _a;
    const { open, loading = false, sysLangPicker = false, title, titleAlt, editableTitle = false, closable = true, padded = true, scroll = true, size = DialogSize_1.default.X450_Y250, onClose, onChangeTitle, onChangeTitleAlt, onChangeTab, buttonsLeft, buttonsRight, childrenRightOfTitle, refChangeTab, children, classes, white = false, tabs = DEFAULT_TABS, } = props;
    const myCss = (0, web_css_1.default)(makeMyClasses, [size, white, tabs], classes);
    const { goBack } = (0, useNav_1.default)();
    const [selectedTabRoute, setSelectedTabRoute] = (0, react_1.useState)((_a = tabs.find(t => t.default)) === null || _a === void 0 ? void 0 : _a.route);
    const handleClose = (0, react_1.useCallback)(() => {
        onClose ? onClose() : goBack();
    }, [goBack, onClose]);
    const handleChangeTab = (0, react_1.useCallback)((_, v) => {
        if (v) {
            onChangeTab === null || onChangeTab === void 0 ? void 0 : onChangeTab(v);
            setSelectedTabRoute(v);
        }
    }, [onChangeTab]);
    if (refChangeTab)
        refChangeTab.current = handleChangeTab;
    const hasTabs = !!tabs.length;
    const isOpen = typeof open !== 'boolean' || !!open;
    const hasTitleBar = title || editableTitle;
    const tabComponent = (0, react_1.useMemo)(() => {
        var _a;
        const selectedTabComponent = hasTabs && !!selectedTabRoute
            ? (_a = tabs.find(t => t.route === selectedTabRoute)) === null || _a === void 0 ? void 0 : _a.component
            : undefined;
        if (!selectedTabComponent)
            return null;
        if (typeof selectedTabComponent === 'function')
            return selectedTabComponent();
        return selectedTabComponent;
    }, [hasTabs, selectedTabRoute, tabs]);
    const content = (0, react_1.useMemo)(() => () => (react_1.default.createElement(Vertical_1.default, { style: Object.assign({ position: 'relative' }, (innerStyle[size] || {})) },
        react_1.default.createElement(Pane_1.default, { padding: padded, scroll: scroll, style: Object.assign({ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0 }, (scrollerStyle[size] || {})) },
            hasTabs && tabComponent,
            !hasTabs && children))), [children, hasTabs, padded, scroll, tabComponent, size]);
    return (0, react_1.useMemo)(() => (react_1.default.createElement(Dialog_1.default, { ref: ref, open: isOpen, onClose: handleClose, maxWidth: false, onClick: e => e.stopPropagation(), keepMounted: true, disableBackdropClick: true, disableEnforceFocus: true, classes: {
            paper: myCss.paper,
        } },
        !!hasTitleBar && (react_1.default.createElement(DialogTitle_1.default, { classes: { root: myCss.title }, disableTypography: true },
            react_1.default.createElement(Vertical_1.default, null,
                react_1.default.createElement(Horizontal_1.default, { stretch: true, centered: true, gutter: true },
                    !!sysLangPicker && react_1.default.createElement(SysLangPicker_1.default, null),
                    react_1.default.createElement(DialogEditableTitle_1.default, { loading: loading, title: title, titleAlt: titleAlt, style: titleStyle[size], editableTitle: editableTitle, onChangeTitle: onChangeTitle, onChangeTitleAlt: onChangeTitleAlt }),
                    childrenRightOfTitle && react_1.default.createElement(Pane_1.default, { grow: true }, childrenRightOfTitle),
                    closable && (react_1.default.createElement(Pane_1.default, null,
                        react_1.default.createElement(IconButton_1.default, { onClick: handleClose, round: true, icon: react_1.default.createElement(CloseDialogIcon_1.default, { size: 20 }) })))),
                hasTabs && !loading && (react_1.default.createElement(Tabs_1.default, { value: selectedTabRoute, onChange: handleChangeTab, indicatorColor: "primary", textColor: "primary" }, tabs.map((tab, idx) => tab.label &&
                    !tab.disabled && (react_1.default.createElement(FeaturedTab_1.default, { key: idx, flag: tab.flag, label: tab.label, value: tab.route })))))))),
        react_1.default.createElement(DialogContent_1.default, { className: myCss.content, style: Object.assign(Object.assign({}, dialogStyle[size]), { maxWidth: '100%' }) },
            react_1.default.createElement(Spinner_1.default, { busy: loading }, content)),
        (buttonsLeft || buttonsRight) && (react_1.default.createElement(DialogActions_1.default, null,
            react_1.default.createElement(Horizontal_1.default, { gutter: true, justify: 'space-between' },
                react_1.default.createElement(Pane_1.default, null, !loading && buttonsLeft),
                react_1.default.createElement(Pane_1.default, null, !loading && buttonsRight)))),
        !hasTitleBar && !!closable && (react_1.default.createElement(IconButton_1.default, { classes: { root: myCss.floatCloseButton }, onClick: handleClose, round: true, icon: react_1.default.createElement(CloseDialogIcon_1.default, { size: 20 }) })))), [
        buttonsLeft,
        buttonsRight,
        childrenRightOfTitle,
        closable,
        content,
        editableTitle,
        handleChangeTab,
        handleClose,
        hasTabs,
        hasTitleBar,
        isOpen,
        loading,
        myCss,
        onChangeTitle,
        onChangeTitleAlt,
        ref,
        selectedTabRoute,
        size,
        sysLangPicker,
        tabs,
        title,
        titleAlt,
    ]);
});
exports.default = exports.Dialog;
